import styled, { css } from 'styled-components';
import { Icon } from '@aon-coverwallet/cw-react-components';
import { SmartLink } from 'src/components/common/smartComponents';

export const StyledSubAgentHeader = styled.div`
  position: fixed;
  z-index: 110;
  width: 100%;
  padding: 0;
  background-color: ${({ backgroundColor, theme: { colors } }) =>
    backgroundColor ? backgroundColor : colors.brand.primary.default};

  @media (max-width: ${({ theme: { sizes } }) => sizes.tablet}) {
    min-height: 56px;
    padding: 0;
  }
`;

export const StyledUserCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: ${({ theme: { sizes } }) => sizes.tablet}) {
    display: ${({ mobileHidden }) => (mobileHidden ? 'none' : 'block')};
    justify-content: center;
  }
`;

export const StyledInnerContainer = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 12px;

  @media (max-width: ${({ theme: { sizes } }) => sizes.tablet}) {
    display: ${({ mobileHidden }) => mobileHidden && 'none'};
    justify-content: center;
  }
`;

const logoContainerStyles = css`
  padding: 5px 15px;

  &:hover {
    background-color: transparent;
  }
`;

export const StyledLogoLinkContainer = styled(SmartLink)`
  ${logoContainerStyles}
`;

export const StyledLogoContainer = styled.div`
  ${logoContainerStyles}
`;

export const StyledLogo = styled.img`
  width: 150px;
  max-height: 50px;
  padding: 0;
  cursor: ${props => (props.link ? 'pointer' : 'initial')};
`;

export const StyledAction = styled(SmartLink)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 15px;
  font-size: 13px;
  color: ${({ theme: { colors } }) => colors.white};
  white-space: nowrap;

  &:hover {
    background-color: ${({ theme: { colors } }) =>
      colors.brand.primary.dark} !important;
    color: ${({ theme: { colors } }) => colors.white};
  }

  @media (max-width: ${({ theme: { sizes } }) => sizes.tablet}) {
    display: none;
  }
`;

export const StyledActionImg = styled.img`
  height: 26px;
`;

export const StyledActionLabel = styled.div`
  margin-top: 2px;
`;

export const StyledActionsContainer = styled.div`
  display: flex;

  @media (max-width: ${({ theme: { sizes } }) => sizes.tablet}) {
    display: none;
  }
`;

export const StyledActionsDropdown = styled.div`
  z-index: 2;
  flex: none;
`;

export const StyledActionButtonWrapper = styled.div`
  a {
    margin-left: 20px;
    padding: 3px 13px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.white};
    background: none;
    border-color: ${({ theme }) => theme.colors.white};

    &:hover {
      color: #8eccf1;
      background: none;
      border-color: #8eccf1;
    }
  }
`;

export const StyledIcon = styled(Icon)`
  height: 26px;
  width: 26px;

  path {
    fill: ${({ theme }) => theme.colors.white};
  }
`;
